export class JournalEntryAttachmentResultDto {
    attachmentId: number;
    fileUrl: string;
    fileName: string;
}
